import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

const Decorator = React.forwardRef(
  (decorator_props, ref) => {
    const Cook = new CookProps(decorator_props)

    return (
      Cook.please(ref)
    )
  }
)

class CookProps {

  constructor (props) {
    this.props = props

    this._saveChildrenProps()
        ._startFillResultProps()
        ._mergeClassNames()
        ._mergeStyles()
        ._mergeMethods()
  }

  children_props = {}
  props = {}

  _mergeClassNames () {
    const {
      props: {
        className
      },
      children_props: {
        className: children_className = ''
      } = {}
    } = this
    if (className || children_className) {
      this.result_props.className = _.trim(
        [
          className || '',
          children_className || ''
        ].join(' '))
    }
    return this

  }

  _mergeMethods () {

    _.each(this.children_props, (childrenMethod, method_name) => {
      if (_.isFunction(childrenMethod)) {
        if (_.isFunction(_.get(this.props, method_name))) {

          this.result_props[method_name] = (...params) => {

            this.props[method_name](...params)
            childrenMethod(...params)

          }
        }
      }
    })

    return this
  }

  _mergeStyles () {

    const {
      props: {
        style = {}
      },
      childrenIsElement,
      children_props
    } = this

    if (childrenIsElement()) {
      const {style: children_style = {}} = children_props
      this.result_props = {
        ...this.result_props,
        style: {
          ...style,
          ...children_style
        }
      }
    } else {
      this.result_props = {
        ...this.result_props,
        style
      }
    }

    return this
  }

  _saveChildrenProps () {

    const children = this.getChildren()

    this.children_props = children.props

    return this
  }

  _startFillResultProps () {

    const {
        default_element_type,
        ...props_without_decorator_options
      } = this.props,
      this_props_without_children = {
        ...props_without_decorator_options,
        children: undefined
      }

    this.result_props = {
      ...this_props_without_children,
      ...this.children_props
    }

    return this
  }

  childrenIsElement = () => {
    const {
      props: {
        children
      }
    } = this
    return React.isValidElement(children)
  }

  getChildren = () => {
    if (this.childrenIsElement()) {
      return React.Children.only(this.props.children)
    } else {
      return false
    }
  }

  please (ref) {
    const {
      props: {
        children,
        default_element_type
      },
      result_props
    } = this

    if (this.childrenIsElement()) {
      return React.cloneElement(children, {
        ...{
          ...result_props,
          ref
        }
      })

    } else {
      return React.createElement(default_element_type, {
        ...{
          ...result_props,
          ref
        }
      }, children)
    }

  }

}

Decorator.defaultProps = {
  default_element_type: 'span'
}
Decorator.propTypes = {
  children: PropTypes.node.isRequired,
  default_element_type: PropTypes.string
}
Decorator.displayName = 'Decorator'

export default Decorator
